import { Base } from '../../abstract/base.model';
import { ChemicalTemplateItem } from './chemical-template-item.model';
import { isRecord } from '../utils/is-record';
import { countOrZero, nullableNumber, nullableString, nullableStringArray } from '../utils/wire-value-utils';

/**
 * A reusable chemical mix of the organization (hub `data-models/chemical-template.ts`), with its items as the hub
 * reads them for the list and detail routes. Templates can be copied into spray records.
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class ChemicalTemplate extends Base {
  // Writable fields
  name?: string | null;
  description?: string | null;
  targetCrops?: string[] | null;
  targetPests?: string[] | null;
  applicationTiming?: string | null;
  totalVolume?: string | null;
  estimatedCostPerAcre?: number | null;
  notes?: string | null;
  /** `undefined` when the hub didn't send the items. */
  items?: ChemicalTemplateItem[];

  // Read-only
  organizationId?: string | null;
  usageCount: number;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.description = nullableString(source['description']);
    this.targetCrops = nullableStringArray(source['targetCrops']);
    this.targetPests = nullableStringArray(source['targetPests']);
    this.applicationTiming = nullableString(source['applicationTiming']);
    this.totalVolume = nullableString(source['totalVolume']);
    this.estimatedCostPerAcre = nullableNumber(source['estimatedCostPerAcre']);
    this.notes = nullableString(source['notes']);
    const items = source['items'];
    this.items = Array.isArray(items) ? items.map(item => new ChemicalTemplateItem(item)) : undefined;
    this.organizationId = nullableString(source['organizationId']);
    this.usageCount = countOrZero(source['usageCount']);
  }
}
